// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file lage/v1/lage.proto (package connectrpc.lage.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LageService", {
    enumerable: true,
    get: function() {
        return LageService;
    }
});
const _lage_pb = require("./lage_pb.js");
const _protobuf = require("@bufbuild/protobuf");
const LageService = {
    typeName: "connectrpc.lage.v1.LageService",
    methods: {
        /**
     * @generated from rpc connectrpc.lage.v1.LageService.RunTarget
     */ runTarget: {
            name: "RunTarget",
            I: _lage_pb.RunTargetRequest,
            O: _lage_pb.RunTargetResponse,
            kind: _protobuf.MethodKind.Unary
        },
        /**
     * a ping function to check if the server is up
     *
     * @generated from rpc connectrpc.lage.v1.LageService.Ping
     */ ping: {
            name: "Ping",
            I: _lage_pb.PingRequest,
            O: _lage_pb.PingResponse,
            kind: _protobuf.MethodKind.Unary
        }
    }
};
